import envConfig from '../../static/config';
import { setAuthTokenForChatbot } from './bridge';
import AppStore from '../stores/AppStore';
import SessionStore from '../stores/SessionStore';
import UserManagementStore from '../stores/UserManagementStore';
import BrowserUtils from '../utils/BrowserUtils';
import {
  CHATBOT_LETS_CHAT_CONTAINER_CLASS_NAME,
  CHATBOT_LETS_CHAT_LINK_ID,
  CHATBOT_LETS_CHAT_LINK_CLASS_NAME,
  CHATBOT_LETS_CHAT_LINK_CLASS_NAME_SMALL,
  CHATBOT_LETS_CHAT_LINK_CLASS_NAME_LARGE,
} from '../constants/ChatbotConstants';

const apiBaseUrlPaas = `${envConfig.apiBaseUrlPAAS}/ibapi/v2`;

function injectChatbotScript() {
  const script = document.createElement('script');
  script.setAttribute('v2', true);
  script.id = 'Microsoft_Omnichannel_LCWidget';
  script.type = 'text/javascript';
  script.async = 'true';
  if (UserManagementStore.isBusinessUser()) {
    script.src = envConfig.chatbot.pvaScriptSource;
    script.setAttribute(
      'data-app-id',
      envConfig.chatbot.businessBankingBot.pvaDataAppId
    );
    script.setAttribute(
      'data-org-id',
      envConfig.chatbot.businessBankingBot.pvaDataOrgId
    );
    script.setAttribute(
      'data-org-url',
      envConfig.chatbot.businessBankingBot.pvaDataOrgUrl
    );
  } else {
    script.src = envConfig.chatbot.pvaScriptSource;
    script.setAttribute('data-app-id', envConfig.chatbot.pvaDataAppId);
    script.setAttribute('data-org-id', envConfig.chatbot.pvaDataOrgId);
    script.setAttribute('data-org-url', envConfig.chatbot.pvaDataOrgUrl);
  }
  script.setAttribute('data-color-override', '#051441');
  script.setAttribute('data-hide-chat-button', 'true');
  script.setAttribute('data-customization-callback', 'lcw');
  document.getElementsByTagName('head')[0].appendChild(script);

  const avatarScript = document.createElement('script');
  avatarScript.text = `function lcw() {
    return {
      webChatContainerProps: {
        renderingMiddlewareProps: {
          avatarStyleProps: {
            backgroundImage:
              "url(https://is3-ssl.mzstatic.com/image/thumb/Purple126/v4/b8/29/42/b8294254-a1cf-5b37-5e36-5ea52c670128/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/492x0w.png)",
            backgroundSize: 'cover'
          },
          avatarTextStyleProps: {
            display: 'none'
          }
        }
      }
    };
  }`;
  document.getElementsByTagName('head')[0].appendChild(avatarScript);
}

function injectLetsChatButton() {
  const isMobileView = BrowserUtils.isMobileView();
  const container = document.createElement('div');
  container.className = CHATBOT_LETS_CHAT_CONTAINER_CLASS_NAME;
  document.body.appendChild(container);

  const link = document.createElement('a');
  link.className = CHATBOT_LETS_CHAT_LINK_CLASS_NAME;
  link.id = CHATBOT_LETS_CHAT_LINK_ID;
  container.appendChild(link);

  const chatImage = document.createElement('img');
  chatImage.src = isMobileView
    ? '../../images/vm/chat-button-floating-icon-small.svg'
    : '../../images/vm/chat-button-floating-icon.svg';
  chatImage.style.maxWidth = 'none';
  link.appendChild(chatImage);

  link.addEventListener('click', () => {
    try {
      window.Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
    } catch (error) {
      window.dtrum?.reportError(error);
    }
  });

  function createScrollStopListener(element, callback, timeout) {
    let handle = null;
    const onScroll = function () {
      link.classList.add(CHATBOT_LETS_CHAT_LINK_CLASS_NAME_SMALL);
      link.classList.remove(CHATBOT_LETS_CHAT_LINK_CLASS_NAME_LARGE);
      if (handle) {
        clearTimeout(handle);
      }
      handle = setTimeout(callback, timeout || 1000);
    };
    element.addEventListener('scroll', onScroll);
    return function () {
      element.removeEventListener('scroll', onScroll);
    };
  }
  createScrollStopListener(window, function () {
    link.classList.remove(CHATBOT_LETS_CHAT_LINK_CLASS_NAME_SMALL);
    link.classList.add(CHATBOT_LETS_CHAT_LINK_CLASS_NAME_LARGE);
  });
}

function loadChatBot() {
  if (!window.auth) {
    setAuthTokenForChatbot(
      apiBaseUrlPaas,
      SessionStore.getURLTokenValue(),
      AppStore.getUserTrackingID()
    );
    injectChatbotScript();

    if (!UserManagementStore.isBusinessUser()) injectLetsChatButton();
  }
}

export { loadChatBot };
